import {axiosNodeClient} from "../http";

function getInboxs (params) {
    return axiosNodeClient.get('/message/inbox', {
        params: {...params}
    });
}

function del(id) {
    return axiosNodeClient.delete('/message/inbox/' + id);
}

export default {getInboxs, del}
